module.exports = __webpack_public_path__ + "img/paystack.f9e58706.png";